/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CriticalNotificationSeverityEnum,
    CriticalNotificationSeverityEnumFromJSON,
    CriticalNotificationSeverityEnumFromJSONTyped,
    CriticalNotificationSeverityEnumToJSON,
} from './CriticalNotificationSeverityEnum';

/**
 * 
 * @export
 * @interface CriticalNotificationDto
 */
export interface CriticalNotificationDto {
    /**
     * 
     * @type {CriticalNotificationSeverityEnum}
     * @memberof CriticalNotificationDto
     */
    severity: CriticalNotificationSeverityEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CriticalNotificationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CriticalNotificationDto
     */
    text: string;
    /**
     * 
     * @type {Date}
     * @memberof CriticalNotificationDto
     */
    activeFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof CriticalNotificationDto
     */
    activeTo: Date;
    /**
     * 
     * @type {Date}
     * @memberof CriticalNotificationDto
     */
    createdAt: Date;
}

export function CriticalNotificationDtoFromJSON(json: any): CriticalNotificationDto {
    return CriticalNotificationDtoFromJSONTyped(json, false);
}

export function CriticalNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriticalNotificationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'severity': CriticalNotificationSeverityEnumFromJSON(json['severity']),
        'id': json['id'],
        'text': json['text'],
        'activeFrom': (new Date(json['activeFrom'])),
        'activeTo': (new Date(json['activeTo'])),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function CriticalNotificationDtoToJSON(value?: CriticalNotificationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'severity': CriticalNotificationSeverityEnumToJSON(value.severity),
        'id': value.id,
        'text': value.text,
        'activeFrom': (value.activeFrom.toISOString()),
        'activeTo': (value.activeTo.toISOString()),
        'createdAt': (value.createdAt.toISOString()),
    };
}

